var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('date-filter-template',{attrs:{"dateType":"End","values":_vm.values,"errors":_vm.errors}}),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("The date from and/or to the date when the event ends.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }